import ajax from '@/helpers/ajax'
import ClickTracking from './click-tracking-mixin'

export default {
  mixins: [ClickTracking],

  props: {
    sharingOptions: {
      type: Object,
      required: true
    }
  },

  computed: {
    channelNameForAnalytics() {
      return 'Email'
    }
  },

  methods: {
    handleClick() {
      const shareClickToken = this.trackEvent()

      ajax.get({
        url: this.sharingOptions.emailShareDataHref,
        params: {
          share_click_token: shareClickToken
        },
        successHandler: ({ subject, body }) => {
          window.location.assign(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`)
        }
      })
    }
  }
}
